// 주로 백엔드에 보낼 때 사용하는 Flag 변수
export const RECEIVE = 1
export const PAY = 2
export const WITHDRAW = 3

// 주로 백엔드에서 온 값을 출력할 때 사용하는 Object
// 사용자 기준이기 때문에, 관리자에선 반대로 출력함
export const convertRecordTypeAsName = {
    "1": "수령",
    "2": "프라이즈로 지급",
    "3": "직접 지급",
    "4": "매니저가 회수",
    "5": "관리자가 회수"
}